<template>
  <div class="px-3 mt-3 pb-14 md:pb-3" v-if="!!products?.length">
    <div class="pb-1 font-niceone-medium">{{ $t('search.product') }}</div>
    <nuxt-link @click="applySearch(product)" v-for="product in products" :key="`search-product-${product?.id}`"
               :to="$routerUrl(product?.seo_url)"
               class="cursor-pointer border-b flex items-center gap-2 bg-white py-1.5 w-full">
      <div class="w-11 h-11 relative rounded-lg overflow-hidden">
        <niceone-image :src="`https:/${product?.thumb}`" loading="eager" class="w-full"/>
      </div>
      <div class="max-w-[50%] space-y-1">
        <div class="text-xs text-grey-muted mb-1 font-niceone-medium">{{ product?.manufacturer }}</div>
        <div class="van-multi-ellipsis--l2 text-xs text-mirage">{{ product?.name }}</div>
      </div>
      <div class="flex-1 h-11 flex items-end justify-end">
        <price v-if="!!product?.special?.length" :increaseFontBy="1" :product="product"
               price-key="price_formatted"></price>
        <niceone-price v-else :price="product?.price_formated" class="font-niceone-bold"/>
      </div>
    </nuxt-link>
  </div>
</template>

<script setup>
import Price from "@/components/product/Price"
import {recentSuggestionWord} from "@/composables/useStoreWord";
import {SEARCH_TYPES} from "@/constants/index";

defineProps({
  products: {
    type: Object,
    default: () => ({}),
  }
})

const applySearch = (product) => {
  if (product) {
    recentSuggestionWord({term: product?.name, type: SEARCH_TYPES.PRODUCT, search_query: product?.seo_url})
  }
}
</script>
<style scoped>
:deep(.line-through) {
  display: flex;
  justify-content: flex-end;
}
</style>